import React from 'react';

export const BathtubSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.0166 17.5544V19.6497C1.0166 22.071 2.79615 24.0844 5.11607 24.451V26H6.63957V24.5108H19.3604V26H20.8839V24.451C23.2038 24.0844 24.9834 22.071 24.9834 19.6497V17.5544H1.0166Z" fill={color} />
        <path d="M2.53991 12.9818V4.19235C2.53991 2.72074 3.73719 1.52351 5.2088 1.52351C6.57168 1.52351 7.69843 2.55052 7.85763 3.87115C6.27121 4.22845 5.08235 5.64785 5.08235 7.34062V8.35646H12.1965V7.34062C12.1965 5.63567 10.9905 4.20778 9.38708 3.86328C9.21843 1.705 7.40958 0 5.2088 0C2.89711 0 1.0164 1.88065 1.0164 4.19235V12.9818H0V16.0312H25.9997V12.9818H2.53991Z" fill={color} />
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5996_18855)">
        <path d="M32 17C33.1046 17 34 16.5523 34 16C34 15.4477 33.1046 15 32 15C30.8954 15 30 15.4477 30 16C30 16.5523 30.8954 17 32 17Z" fill="#99AAB5" />
        <path d="M33 21C32.447 21 32 20.553 32 20V4C32 2.418 30.038 2 29 2C27.962 2 26 2.418 26 4C26 4.552 25.553 5 25 5C24.447 5 24 4.552 24 4C24 1.374 26.516 0 29 0C31.484 0 34 1.374 34 4V20C34 20.553 33.553 21 33 21Z" fill="#CCD6DD" />
        <path d="M28 6C28 7.104 26.657 7 25 7C23.343 7 22 7.104 22 6C22 4.896 23.343 4 25 4C26.657 4 28 4.896 28 6Z" fill="#99AAB5" />
        <path d="M29 7C29 7.552 28.553 8 28 8H22C21.447 8 21 7.552 21 7C21 6.448 21.447 6 22 6H28C28.553 6 29 6.448 29 7Z" fill="#CCD6DD" />
        <path d="M12 36C13.1046 36 14 35.1046 14 34C14 32.8954 13.1046 32 12 32C10.8954 32 10 32.8954 10 34C10 35.1046 10.8954 36 12 36Z" fill="#99AAB5" />
        <path d="M28 36C29.1046 36 30 35.1046 30 34C30 32.8954 29.1046 32 28 32C26.8954 32 26 32.8954 26 34C26 35.1046 26.8954 36 28 36Z" fill="#99AAB5" />
        <path d="M29.9998 34.0001H11.9998C6.99976 34.0001 1.99976 28.0001 0.999758 20.0001C0.751758 18.0161 1.81176 19.0001 4.02076 19.0001C4.02076 19.0001 16.9998 21.0001 29.9998 21.0001C31.9998 21.0001 34.9998 19.7911 34.9998 22.0001C34.9998 22.0001 33.9998 34.0001 29.9998 34.0001Z" fill="#CCD6DD" />
        <path d="M36 21C36 21.553 35.553 22 35 22L1 20C0.448 20 0 19.553 0 19C0 18.447 0.448 18 1 18L35 20C35.553 20 36 20.447 36 21Z" fill="#99AAB5" />
      </g>
      <defs>
        <clipPath id="clip0_5996_18855">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}